module.exports = __webpack_public_path__ + "static/media/arcane_circle.76cb8fdd.png";